import { UNSUPPORTED_STATUS_CODES } from '../../components/constants';

const layoutIssueSearchFields = (schema = [], hiddenFields = []) => {
  const hiddenFieldNames = new Set(hiddenFields);
  const visibleFields = schema
    .filter(field => !hiddenFieldNames.has(field.name))
    .map(field =>
      field.name === 'statusCode'
        ? { ...field, excludedCodes: UNSUPPORTED_STATUS_CODES }
        : field,
    );
  const statusField = visibleFields.find(field => field.name === 'statusCode');
  const assigneeField = visibleFields.find(
    field => field.name === 'assigneeUserId',
  );
  const instanceField = visibleFields.find(
    field => field.name === 'serviceAdministratorId',
  );
  const pairedFieldNames =
    statusField && assigneeField
      ? new Set(['statusCode', 'assigneeUserId'])
      : new Set();
  const fieldsBeforeAssignment = visibleFields.filter(
    field =>
      !pairedFieldNames.has(field.name) &&
      field.name !== 'serviceAdministratorId',
  );
  const layoutFields = fields =>
    fields.map((field, index) => ({
      ...field,
      column: (index % 2) + 1,
      row: Math.floor(index / 2) + 1,
    }));
  const laidOutFields = layoutFields(fieldsBeforeAssignment);

  const nextRow = Math.ceil(fieldsBeforeAssignment.length / 2) + 1;
  const assignmentFields =
    statusField && assigneeField
      ? [
          { ...statusField, column: 1, row: nextRow },
          { ...assigneeField, column: 2, row: nextRow },
        ]
      : [];
  const instanceRow = nextRow + (assignmentFields.length ? 1 : 0);

  return [
    ...laidOutFields,
    ...assignmentFields,
    ...(instanceField
      ? [{ ...instanceField, column: 1, row: instanceRow }]
      : []),
  ];
};

export default layoutIssueSearchFields;
